<template>
  <div id="chart">
    <div class="mainDiv">
      <el-row>
        <el-col id="div1" style="height:40vh;" :span="8"></el-col>
        <el-col id="div2" style="height:40vh;" :span="8"></el-col>
        <el-col id="div3" style="height:40vh;" :span="8"></el-col>
      </el-row>
      <el-row>
        <el-col id="div4" style="height:40vh;" :span="8"></el-col>
        <el-col id="div5" style="height:40vh;" :span="8"></el-col>
        <el-col id="div6" style="height:40vh;" :span="8"></el-col>
      </el-row>
      <!-- <el-row>
        <el-col id="div7" style="height:28vh;" :span="8"></el-col>
        <el-col id="div8" style="height:28vh;" :span="8"></el-col>
        <el-col id="div9" style="height:28vh;" :span="8"></el-col>
      </el-row> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'chart',
  data () {
    return {
      div1: '',
      div2: '',
      div3: '',
      div4: '',
      div5: '',
      div6: '',
      // div7: '',
      // div8: '',
      // div9: '',
    }
  },
  mounted: function () {
    this.init();
  },
  methods: {
    init(){
      this.div1=this.$echarts.init(document.getElementById('div1'));
      this.div2=this.$echarts.init(document.getElementById('div2'));
      this.div3=this.$echarts.init(document.getElementById('div3'));
      this.div4=this.$echarts.init(document.getElementById('div4'));
      this.div5=this.$echarts.init(document.getElementById('div5'));
      this.div6=this.$echarts.init(document.getElementById('div6'));
      // this.div7=this.$echarts.init(document.getElementById('div7'));
      // this.div8=this.$echarts.init(document.getElementById('div8'));
      // this.div9=this.$echarts.init(document.getElementById('div9'));

      let that = this;
      var tempDate;
      var legendTemp = [];
      var seriesTemp = [];
      var optionTemp = {};
      this.$axios.get('/Total/getPieData').then(res => {
        tempDate = res.data.pie1;
        legendTemp = [];
        for(var i=0;i<tempDate.length;i++){
          legendTemp.push(tempDate[i]['name']);
        }
        optionTemp = {
            title: {
                text: '工作总量统计',
                subtext: '',
                left: 'center'
            },
            tooltip: {
                trigger: 'item',
                formatter: '{b} : {c}个 ({d}%)'
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                data: legendTemp
            },
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: tempDate,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        }
        that.div1.setOption(optionTemp);

        legendTemp = [];
        tempDate = res.data.pie2;
        for(var i=0;i<tempDate.length;i++){
          legendTemp.push(tempDate[i]['name']);
        }
        optionTemp = {
            title: {
                text: '按类别统计公文数量',
                subtext: '',
                left: 'center'
            },
            tooltip: {
                trigger: 'item',
                formatter: '{b} : {c}个 ({d}%)'
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                data: legendTemp
            },
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: tempDate,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        }
        that.div2.setOption(optionTemp);

        legendTemp = [];
        tempDate = res.data.pie3;
        for(var i=0;i<tempDate.length;i++){
          legendTemp.push(tempDate[i]['name']);
        }
        optionTemp = {
            title: {
                text: '按状态统计公文数量',
                subtext: '',
                left: 'center'
            },
            tooltip: {
                trigger: 'item',
                formatter: '{b} : {c}个 ({d}%)'
            },
            legend: {
                orient: 'vertical',
                left: 'left',
                data: legendTemp
            },
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: tempDate,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        }
        that.div3.setOption(optionTemp);
      })

      this.$axios.get('/Total/getLineData').then(res => {
        tempDate = res.data.line1;
        legendTemp = [];
        seriesTemp = [];
        for(var i=0;i<tempDate.length;i++){
          legendTemp.push(tempDate[i]['name']);
          seriesTemp.push(tempDate[i]['value'])
        }
        optionTemp = {
            title: {
                text: '本年度按月统计公文数量'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    data: legendTemp
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: '公文数量',
                    type: 'line',
                    stack: '总量',
                    areaStyle: {},
                    data: seriesTemp,
                    smooth: true
                }
            ]
        };
        that.div4.setOption(optionTemp);

        legendTemp = [];
        seriesTemp = [];
        tempDate = res.data.line2;
        for(var i=0;i<tempDate.length;i++){
          legendTemp.push(tempDate[i]['name']);
          seriesTemp.push(tempDate[i]['value'])
        }
        optionTemp = {
            title: {
                text: '本年度按月统计通知数量'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    data: legendTemp
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: '通知数量',
                    type: 'line',
                    stack: '总量',
                    areaStyle: {},
                    data: seriesTemp,
                    smooth: true,
                    color: '#b2d7c6'
                }
            ]
        };
        that.div5.setOption(optionTemp);

        legendTemp = [];
        seriesTemp = [];
        tempDate = res.data.line3;
        for(var i=0;i<tempDate.length;i++){
          legendTemp.push(tempDate[i]['name']);
          seriesTemp.push(tempDate[i]['value'])
        }
        optionTemp = {
            title: {
                text: '本年度按月统计短信数量'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    data: legendTemp
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: '短信数量',
                    type: 'line',
                    stack: '总量',
                    areaStyle: {},
                    data: seriesTemp,
                    smooth: true,
                    color: '#6d7b85'
                }
            ]
        };
        that.div6.setOption(optionTemp);
      })
    },
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/chart/all.vue